<template>
    <div class="card card-custom gutter-b h-100">
        <div class="card-header">
            <div class="card-title">
                Danh sách kiểm toán
            </div>
        </div>
        <!--    body-->
        <div class="card-body">
            <div class="row">
                <div class="col-md-2 col-sm-12 mb-3">
                    <h4 style="font-size: 13px">Học viên</h4>
                    <el-input placeholder="Nhập tên, SĐT, mã học viên" clearable @input="changeValue" v-model="query.keyword" ></el-input>
                </div>
                <div class="col-md-2 col-sm-12 mb-3">
                    <h4 style="font-size: 13px">Thời gian</h4>
                    <el-date-picker
                        v-model="query.range"
                        type="daterange"
                        style="width: 100%"
                        range-separator="-"
                        start-placeholder="Bắt đầu"
                        @change="changeValue"
                        :picker-options="pickerOptions"
                        value-format="yyyy-MM-dd"
                        end-placeholder="kết thúc">
                    </el-date-picker>
                </div>
                <div class="col-md-2 col-sm-12 mb-3">
                    <h4 style="font-size: 13px">Trung tâm</h4>
                    <el-select filterable v-model="query.center" @change="handleCenter" clearable placeholder="Chọn trung tâm">
                        <el-option :value="center.id" :key="center.id" :label="center.value" v-for="center in listCenter"></el-option>
                    </el-select>
                </div>
                <div class="col-md-2 col-sm-12 mb-3">
                    <h4 style="font-size: 13px">Chi nhánh</h4>
                    <el-select v-model="query.branch" @change="changeValue" filterable clearable placeholder="Chọn Chi nhánh">
                        <el-option :value="branch.id" :key="branch.id" :label="`${branch.name}`" v-for="branch in listBranch"></el-option>
                    </el-select>
                </div>
                <div class="col-md-2 col-sm-12 mb-3">
                    <h4 style="font-size: 13px">Trạng thái </h4>
                    <el-select v-model="query.status" @change="changeValue" clearable placeholder="Chọn trạng thái">
                        <el-option :value="status.id" :key="status.id" :label="`${status.value}`" v-for="status in statusOption"></el-option>
                    </el-select>
                </div>
                <div class="col-md-2 col-sm-12 mb-3">
                    <h4 style="font-size: 13px">Hình thức thanh toán </h4>
                    <el-select v-model="query.payment" @change="changeValue" clearable placeholder="Chọn hình thức thanh toán">
                        <el-option :value="status.id" :key="status.id" :label="`${status.value}`" v-for="status in paymentOption"></el-option>
                    </el-select>
                </div>
            </div>
            <div class="mt-10 table-responsive scroll-x">

                <table v-if="Number(query.payment) !== 1"
                       class="table table-bordered text-center table-vertical-center wide-table">
                    <thead>
                    <tr style="background-color: #F8F8F8 ; font-size: 13px">
                        <th>Mã HĐ</th>
                        <th>Tên học viên</th>
                        <th>Mã học viên</th>
                        <th>Số điện thoại</th>
                        <th>Số tiền nạp</th>
                        <th>Bên thu tiền</th>
                        <th>Người tạo</th>
                        <th>Chi nhánh</th>
                        <th>Thời gian nạp</th>
                        <th>Thời gian kiểm toán</th>
                        <th>Trạng thái</th>
                        <th class="note-col">Ghi chú</th>
                        <th>Hành động</th>
                    </tr>
                    </thead>
                    <tbody v-if="items.length === 0">
                    <tr >
                        <td v-loading="loading"  colspan="13">
                            Không có dữ liệu.
                        </td>
                    </tr>
                    </tbody>
                    <tbody>
                    <tr v-for="(item, index) in items">
                        <td>{{ item.contract_id }}</td>
                        <td>{{ item.user_name }}</td>
                        <td>{{ item.user_id }}</td>
                        <td>{{ item.phone }}</td>
                        <td>{{ item.amount | formatVND }}</td>
                        <td>{{ item.ben_thu_tien }}</td>
                        <td>{{ item.nguoi_tao }}</td>
                        <td>{{ item.branch }}</td>
                        <td>{{ item.created_at }}</td>
                        <td>{{ item.audit_date }}</td>
                        <td>
                            <el-tag v-if="item.audit_status !== -1" :type="getStatusById(item.audit_status).type"
                                    effect="dark">
                                {{ item.status_string }}
                            </el-tag>
                        </td>
                      <td class="note-col">
                        <div class="note-clamp">{{ item.audit_note }}</div>
                      </td>
                        <td>
                            <i v-if="[0,2,3,4,5].includes(item.audit_status)"  @click="openDialogEdit(item)" style="color: orange; font-size: 24px; cursor: pointer; margin-right: 12px; cursor: pointer;" size="large" class="el-icon-edit-outline "></i>

                            <i v-if="item.payments_status === 2" style="color: green; cursor: pointer; font-size: 24px" size="large" class="el-icon-refresh "></i>
                        </td>
                    </tr>
                    </tbody>
                </table>
                <table v-else class="table table-bordered text-center table-vertical-center wide-table">
                    <thead>
                    <tr style="background-color: #F8F8F8 ; font-size: 13px">
                        <th>Tổng số tiền quẹt thẻ</th>
                        <th>Tổng số tiền nhận được</th>
                        <th>Thời gian quẹt thẻ</th>
                        <th>Thời gian kiểm toán</th>
                        <th>Trạng thái</th>
                        <th class="note-col">Ghi chú</th>
                        <th>Hành động</th>
                    </tr>
                    </thead>
                    <tbody v-if="items.length === 0">
                    <tr >
                        <td v-loading="loading"  colspan="13">
                            Không có dữ liệu.
                        </td>
                    </tr>
                    </tbody>
                    <tbody>
                    <tr v-for="(item, index) in items">
                        <td>{{ item.amount | formatVND }}</td>
                        <td>{{ item.receive_amount | formatVND }}</td>
                        <td>
                            {{
                                item.business_date_start === item.business_date_end ? 'Ngày ' + item.business_date_start : 'Từ ' + item.business_date_start + ' đến' + item.business_date_end
                            }}
                        </td>
                        <td>{{ item.audit_time }}</td>
                        <td>
                            <el-tag v-if="item.audit_status !== -1" :type="getStatusById(item.audit_status).type"
                                    effect="dark">
                                {{ item.status_string }}
                            </el-tag>
                        </td>
                        <td>{{ item.audit_note }}</td>
                        <td>
                            <i v-if="[0,2,3,4,5].includes(item.audit_status)" class="el-icon-edit-outline "
                               size="large"
                               style="color: orange; font-size: 24px; cursor: pointer; margin-right: 12px; cursor: pointer;" @click="openDialogEdit(item)"></i>

                            <i v-if="item.payments_status === 2" class="el-icon-refresh "
                               size="large" style="color: green; cursor: pointer; font-size: 24px"></i>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div class="mb-0 d-flex flex-row-reverse mr-10">
            <p class="mb-0">Tổng số bản ghi: <span class="text-primary ">{{total}}</span></p>
        </div>
        <div class="edu-paginate mx-auto text-center mt-5">
            <paginate
                v-model="page"
                :page-count="last_page"
                :page-range="3"
                :margin-pages="1"
                :click-handler="clickCallback"
                :prev-text="'Trước'"
                :next-text="'Sau'"
                :container-class="'pagination b-pagination'"
                :pageLinkClass="'page-link'"
                :next-link-class="'next-link-item'"
                :prev-link-class="'prev-link-item'"
                :prev-class="'page-link'"
                :next-class="'page-link'"
                :page-class="'page-item'"
            >
            </paginate>
        </div>
        <el-dialog class="type-audit" title="Xử lý lỗi kiểm toán"  width="30%" :visible.sync="dialogVisible">
            <el-form :model="form" :rules="rules" ref="form"  >
                <el-form-item label="Ghi chú" >
                    <el-input type="textarea" maxlength="200" show-word-limit placeholder="Nhập ghi chú" v-model="form.note" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="Đánh dấu đã xử lý" prop="status">
                    <el-select v-model="form.status" style="width: 100%" placeholder="Chọn trạng thái xử lý">
                        <el-option label="Đã xử lý" value="4"></el-option>
                        <el-option label="Chưa xử lý" value="5"></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">Hủy bỏ</el-button>
                <el-button :loading="loadingSave" style="background: #5D04B0; color: white" @click="submitForm('form')" >Xác nhận</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import {SET_BREADCRUMB} from "@/core/services/store/breadcrumbs.module";
import {AUDIT_CREATE_STUDENT_AMOUNT, AUDIT_GET_STUDENT_AMOUNT} from "@/core/services/store/audit/audit.module";
import {StudentAmountModel} from "./Models/StudentAmountModel";
import {GET_LIST_BRANCH_IS_EDUTALK} from "@/core/services/store/test/testInput.module";
import {AuditPayooModel} from "./Models/AuditPayooModel";
import {AUDIT_PAYOO_STATUS} from "../../../core/services/store/audit/audit.module";

export default {
    name: "AuditList",
    data() {
        return {
            publicPath: process.env.VUE_APP_BASE_URL + '/icons/',
            loading: false,
            query: {
                range: null,
                center: null,
                branch: null,
                status: null,
                payment: null,
                keyword: null,
            },
            listBranch: [],
            listCenter: [
                {"id": 516, "value": "IELTS Mentor"},
                {"id": 295, "value": "Ecoach"},
            ],
            statusOption: [
                {"id": 2, "value": "Chưa nhận"},
                {"id": 3, "value": "Sai tiền"},
                {"id": 4, "value": "Đã xử lý"},
            ],
            paymentOption: [
                {"id": "1", "value": "Quẹt thẻ"},
                {"id": "2", "value": "Chuyển khoản"},
            ],
            paymentsStatus: [
                {id: -1,type: '', label: ''},
                {id: 1, type: 'success', label: 'Đã nạp'},
                {id: 2, type: 'danger', label: 'Chưa nhận'},
                {id: 3, type: 'warning', label: 'Sai số tiền'},
                {id: 4, type: 'primary', label: 'Đã xử lý'},
                {id: 5, type: 'info', label: 'Chưa xử lý'}
            ],
            items: [],
            selectedId: 0,
            page: 1,
            last_page: 0,
            total: 0,
            dialogVisible: false,
            loadingSave: false,
            pickerOptions: {
                disabledDate(time) {
                    // Disable tất cả ngày sau hôm nay
                    return time.getTime() > Date.now()
                }
            },
            form: {
                note: '',
                status: '',
                id: 0
            },
            rules: {
                status: [
                    {required: true, message: 'Chọn trạng thái xử lý', trigger: 'blur'},
                ],
            },
            typeOptions: [
                {id: 1, label: "Phí thi Ielts (IDP)"},
                {id: 2, label: "Phí thi lại EC"},
                {id: 3, label: "Phí thi lại IM ( tên các vp IM)"},
                {id: 4, label: "Phí bảo lưu"},
                {id: 5, label: "Phí học lại"},
                {id: 6, label: "Phí  DA bổ trợ cấp tốc"},
                {id: 7, label: "Phí payoo IM ( tên các vp IM)"},
                {id: 8, label: "Học phí Quantum leap"},
                {id: 9, label: "Thanh toán BHXH"},
                {id: 10, label: "Hoàn cọc"},
                {id: 11, label: "Hoàn dư"},
            ]
        }
    },
    watch: {
      dialogVisible(newVal) {
        if (!newVal) {
          this.form = {
            note: '',
            status: '',
          }
        }
      }
    },
    async mounted() {
        this.$store.dispatch(SET_BREADCRUMB, [
            { title: "Kiểm toán", route: "" },
            { title: "Danh sách kiểm toán" },
        ]);
        this.query = this.$router.currentRoute.query
        await this.getListBranchIsEdutalk()
        this.getList();
    },
    methods: {
        async getListBranchIsEdutalk() {
            return this.$store.dispatch(GET_LIST_BRANCH_IS_EDUTALK, {
                center_id: this.query.center ? [this.query.center] : [516, 295]
            }).then((res) => {
                this.listBranch = [{name: 'Tất cả', id: 0}, ...res.data];
            })
        },
        handleCenter() {
            this.office = [0];
            this.listBranch = [];
            this.getListBranchIsEdutalk()
            this.changeValue();
        },
        openDialogEdit(item) {
          let auditNote = item.audit_status;
          this.form.id = item.id;
          this.form.note = item.audit_note;
          if ([4, 5].includes(auditNote)) {
            this.form.status = String(auditNote);
          }
          this.dialogVisible = true;
        },
        getList() {
            this.loading = true
            let payment = Number(this.query.payment);
            this.$store.dispatch(AUDIT_GET_STUDENT_AMOUNT, {page: this.page, ...this.query})
                .then((data) => {
                    this.items = data.data.map((report) => payment === 1 ? new AuditPayooModel(report) : new StudentAmountModel(report));
                    this.total = data.pagination.total;
                    this.loading = false;
                    this.page = data.pagination.page;
                    this.last_page = data.pagination.last_page;
                })
        },
        changeValue() {
            let query = { ...this.page, ...this.query }
            Object.keys(query).forEach(key => {
                if (query[key] === null || query[key] === undefined || query[key] === '') {
                    delete query[key]
                }
            })
            this.$router.push({
                name: 'audit-list',
                query: { ...this.page, ...query, t: Date.now() } // force refresh
            })
            this.getList()
        },
        getStatusById(id)  {
            return this.paymentsStatus.find((item) => {
                return item.id === parseInt(id)
            })
        },
        clickCallback(obj) {
            this.page = obj;
            this.getList();
        },
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.updateTransaction()
                } else {
                    return false;
                }
            });
        },
        resetForm(formName) {
            this.$refs[formName].resetFields();
        },
        updateTransaction() {
            this.loadingSave = true;
            let API_URL = this.form.payment && this.form.payment == 1 ? AUDIT_PAYOO_STATUS : AUDIT_CREATE_STUDENT_AMOUNT
            this.$store.dispatch(API_URL, this.form)
                .then((res) => {
                    if (!res.error) {
                        this.items.map((item) => {
                            if (item.id === this.form.id) {
                                item.audit_status = this.form.status;
                                item.audit_note = this.form.note;
                                item.status_string = parseInt(this.form.status) === 4 ? 'Đã xử lý' : 'Chưa xử lý';
                            }
                        })
                        this.$bvToast.toast(res.message, {
                            title: 'Xử lý lỗi kiểm toán',
                            variant: 'success',
                            solid: true
                        });
                    } else {
                        this.$bvToast.toast(res.message, {
                            title: 'Xử lý lỗi kiểm toán',
                            variant: 'error',
                            solid: true
                        });
                    }
                    this.dialogVisible = false;
                    this.loadingSave = false;
                })
        },
    }
}
</script>
<style>
.type-audit .el-dialog__body {
    padding: 10px 20px 30px !important;
}
.type-audit .el-form-item {
    margin-bottom: 10px !important;
}
.type-audit .el-form-item__label {
    line-height: unset !important;
}
.type-audit .el-dialog__body .el-form-item.is-required:not(.is-no-asterisk)>.el-form-item__label::before{
    display: none !important;
}
.type-audit .el-dialog__body .el-form-item.is-required:not(.is-no-asterisk)>.el-form-item__label::after{
    content: '*';
    color: red;
    margin-left: 4px;
}
.scroll-x {
  width: 100%;
  overflow-x: auto;
  overflow-y: hidden;
  -webkit-overflow-scrolling: touch;
}

.wide-table {
  min-width: 1400px;
  table-layout: auto;
  border-collapse: separate;
}

.wide-table th,
.wide-table td {
  white-space: nowrap;
}

.wide-table thead th {
  position: sticky;
  top: 0;
  background: #fff;
  z-index: 2;
}
.note-col{
  width: 600px !important;
  min-width: 200px;
  max-width: 600px;
  white-space: normal !important;
  text-align: left;
}

.note-clamp{
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;

  word-break: break-word;
  overflow-wrap: anywhere;

  line-height: 1.4;
  max-height: calc(1.4em * 3);     /* fallback */
}
</style>